module.exports = __webpack_public_path__ + "img/0405f88.svg";